var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monitoring-wrap"},[_c('template-search-read',{attrs:{"readApi":_vm.readApi,"reload":_vm.reload},on:{"button":_vm.button,"searchFilter":_vm.getSearchFilter}}),_c('email-detail',{attrs:{"apiParam":_vm.apiParam,"infoApi":_vm.infoApi,"editApi":_vm.editApi},on:{"button":_vm.button}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }